<script context="module" lang="ts">export { specification } from "./spec";
</script>

<script lang="ts">import { BaseAtom, getMergedParams } from "components/cards/atoms";
export let container = undefined;
export let matchIdType = undefined;
export let matchIds = undefined;
export let format = undefined;
export let layoutType = undefined;
export let competition = undefined;
export let keyMomentsOnly = undefined;
export let pollSeconds = undefined;
export let pageSize = undefined;
// Same fallback behavior as the janus4 atom: the CMS value wins; when it is
// missing (or an unexpanded {{...}} template), fall back to the standard
// gameId query-string parameter from the merged page params.
const mergedParams = getMergedParams();
$: resolvedMatchIds = matchIds && !matchIds.includes("{{") ? matchIds : ($mergedParams === null || $mergedParams === void 0 ? void 0 : $mergedParams.gameId) || "";
</script>

<BaseAtom _isotope="NVPlayVideoHighlightsAtom" {...container}>
  <div>NVPlayVideoHighlightsAtom{resolvedMatchIds ? ` (match: ${resolvedMatchIds})` : ""}</div>
</BaseAtom>
